<div class="welcome-page flex justify-center items-center">
  <div
    class="flex justify-evenly items-center flex-col welcome-page__content"
  >
    <div class="welcome-page__header flex flex-col items-center">
      <img
        *ngIf="orgConfig?.LOGO_URL"
        [src]="orgConfig?.LOGO_URL"
        [alt]="orgConfig?.NAME | propertyTranslator"
        height="250"
        class="mb-6"
      />
      <h2
        class="line-clamp welcome-page__fullname"
        [title]="
          'pages.welcome.welcome'
            | translate: { value: currentUser?.full_name | propertyTranslator }
        "
      >
        {{
          "pages.welcome.welcome"
            | translate: { value: currentUser?.full_name | propertyTranslator }
        }}
      </h2>
    </div>

    <nav class="welcome-page__list mt-6">
      <a
        class="!inline-flex justify-evenly items-center flex-col cursor-pointer"
        (click)="onStartUsingClicked()"
        (keyup.enter)="onStartUsingClicked()"
      >
        <svg width="48" height="54">
          <use xlink:href="/assets/images/public/shuttle.svg#shuttle"></use>
        </svg>
        <span>{{
          "pages.welcome.START_USING_SYSTEM"
            | translate: { value: orgConfig?.NAME | propertyTranslator }
            | uppercase
        }}</span>
      </a>
      <a
        href="#"
        target="_blank"
        class="!inline-flex justify-evenly items-center flex-col"
      >
        <svg width="48" height="54">
          <use xlink:href="/assets/images/public/maps.svg#maps"></use>
        </svg>
        <span>{{
          "pages.welcome.SYSTEM_TUTORIALS"
            | translate: { value: orgConfig?.NAME | propertyTranslator }
            | uppercase
        }}</span>
      </a>
      <a
        target="_blank"
        href="#"
        class="!inline-flex justify-evenly items-center flex-col"
      >
        <svg width="48" height="54">
          <use xlink:href="/assets/images/public/info.svg#info"></use>
        </svg>

        <span>{{
          "pages.welcome.ABOUT_SYSTEM"
            | translate: { value: orgConfig?.NAME | propertyTranslator }
            | uppercase
        }}</span>
      </a>
    </nav>
  </div>
</div>
